import React from 'react';
import './Form.scss'

const FormLabel = ({ children }) => {
  return <label className="formLabel">{children}</label>;
};

export default FormLabel;
